import BaseStyle from '@primevue/core/base/style';

var ColumnStyle = BaseStyle.extend({
  name: 'column'
});

export { ColumnStyle as default };
//# sourceMappingURL=index.mjs.map
